import Vue from 'vue'
import { VueReCaptcha } from "vue-recaptcha-v3";

export default () => {
  Vue.use(VueReCaptcha, {
    siteKey: "6LcFxbkcAAAAADTPP1n_Czl9TtJB3iL6rEU_5yON"
  })

  return VueReCaptcha
}